<template>
  <div class="text-field">
    <label class="field-label">
      {{ label }}
      <span v-if="required" class="u-color-danger"> *</span>
    </label>
    <div class="input-field">
      <input :id="inputId" v-model="localValue" @blur="$emit('blur')" v-bind="{...$props, ...$attrs}" v-bind:class="{ 'icon-padding': ['month', 'date', 'time'].includes(type), 'error': !!errorMessage }"></input>
      <PublishBadge v-if="isPublish" class="publish-badge"></PublishBadge>
    </div>
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script lang="babel">
import PublishBadge from "@/components/PublishBadge";

export default {
  name: "TextField",
  components: {PublishBadge},
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    isPublish: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    inputId: {
      type: String,
      required: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        // 空文字はnull扱い
        if (newValue != null && newValue.length <= 0) {
          this.$emit('input', null);
        } else {
          this.$emit('input', newValue);
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.icon-padding {
  padding-right: 44px;
}

.text-field {
  position: relative;
}

.field-label, .input-field > input::placeholder {
  color: #CAC9C9;
}

.input-field > input {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
  border: none;
  letter-spacing: 0.03rem;
  outline: none;
  height: 42px;
  width: 100%;
  -webkit-appearance: none;
  border-radius: 1px;
  appearance: none;
}

.input-field input:focus {
  box-shadow: 0px 2px 0px #F94848;
}

.error {
  box-shadow: 0 2px 0 #f94848 !important;
  background: rgba(241, 72, 72, .1);
}

.error-message {
  padding-top: 7px;
  padding-bottom: 7px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: .03em;
  color: #f14848;
  height: 40px;
}

.publish-badge {
  font-size: 10px;
  position: absolute;
  right: 5px;
  top: 30%;
  background-color: white;
}
</style>
